import { useEffect } from 'react';
export var useModalOverlay = function useModalOverlay(isVisible) {
  useEffect(function () {
    if (isVisible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [isVisible]);
};